import { render, staticRenderFns } from "./ContrattiDiServizio.vue?vue&type=template&id=3aeca27e&scoped=true"
import script from "./ContrattiDiServizio.vue?vue&type=script&lang=js"
export * from "./ContrattiDiServizio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeca27e",
  null
  
)

export default component.exports